import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HorizonPlacementEnum, NiveauDeRisque, ToleranceRisque } from '@lib/models/generated/graphql';
import { OuiBanner } from 'omnium-ui/banner';
import { AllocationService, HorizonRetraite, PatrimoineWarning } from 'src/app/services/allocation.service';

@Component({
  selector: 'app-allocation-rules-banner',
  standalone: true,
  imports: [OuiBanner, CommonModule],
  templateUrl: './allocation-rules-banner.component.html',
  styleUrl: './allocation-rules-banner.component.scss',
})
export class AllocationRulesBannerComponent {
  horizonRetraite = HorizonRetraite;
  horizonPlacement = HorizonPlacementEnum;
  patrimoineWarning = PatrimoineWarning;
  toleranceRisque = ToleranceRisque;
  profile = NiveauDeRisque;
  constructor(protected allocationService: AllocationService) {}
}
